import { useQuery } from "@msuite/ui/query";
import { client } from "@/hono";

/**
 * The rendered PDF label for one warehouse zone.
 *
 * `responseHandler` is deliberately not used, for the reason `useTransferCarrierLabel` gives: the
 * route answers PDF bytes rather than the `{ success, … }` envelope every other route answers, so
 * there is no body to read a failure out of. The status reports it instead, and the thrown error
 * is what the card renders its own message from.
 *
 * The label is derived from the zone row, so it is stale exactly when that row is — the query key
 * names the zone, and invalidating `warehouse-zone` alongside it after an edit is what reprints a
 * renamed hall.
 */
export function useWarehouseZoneLabel(warehouseZoneId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["warehouse-zone-label", warehouseZoneId],
		queryFn: async () => {
			const response = await client.stock["warehouse-zones"][":warehouseZoneId"].label.$get({
				param: { warehouseZoneId },
			});
			if (!response.ok) throw new Error("Could not render the warehouse zone label");
			return await response.blob();
		},
	});

	/** Return */
	return { ...query, label: query.data ?? null };
}
